import axiosInstance from '../api/axios';

const dictionary = {
    poor : 0,
    fair : 1,
    good : 2,
    excellent : 3
}
const analyzeData = (data) => {
    // Perform your analysis here
    // Let's assume we want to extract useful information from evaluations
    const evaluations = data.evaluations || [];
    console.log('analysis', data.data, dictionary[data.data.dataSelection])
    // Example analysis
    const analysis = evaluations.map((evaluation) => ({
        value: (parseInt(dictionary[evaluation.effort]) + parseInt(dictionary[evaluation.dataSelection]) + parseInt(dictionary[evaluation.literature]) + parseInt(dictionary[evaluation.effort]) + parseInt(dictionary[evaluation.satisfaction]) + parseInt(dictionary[evaluation.updates]))/6
        
        // You can add more derived data or statistics here
    }));
   // console.log('analysis', parseInt(dictionary[evaluation.effort]), analysis.value)
    return {
        evaluationResult: analysis.value,
    };
};


export const getStudentSelfEvaluation = async (id) => {
    try {
        const response = await axiosInstance.get(`/getEvaluationStudentId?id=${id}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching students:', error);
        throw error;
    }
};

